import React, { FC } from "react";

interface ShareControllerProps {
  children: React.ReactNode;
  shareData: ShareData;
  onSuccess?: () => void;
  onError?: (error?: unknown) => void;
  onNonNativeShare?: () => void;
  onInteraction?: () => void;
  disabled?: boolean;
}

const ShareController: FC<ShareControllerProps> = ({ children, shareData, onInteraction, onSuccess, onError, onNonNativeShare, disabled }) => {
  const handleOnClick = async () => {
    onInteraction?.();
    if (navigator?.share) {
      try {
        await navigator.share(shareData);
        onSuccess?.();
      } catch (err) {
        onError?.(err);
      }
    } else {
      onNonNativeShare?.();
    }
  };

  return (
    <button onClick={handleOnClick} type="button" disabled={disabled}>
      {children}
    </button>
  );
};

export default ShareController;
